import { render, staticRenderFns } from "./doSeal.vue?vue&type=template&id=64b4bf80"
import script from "./doSeal.vue?vue&type=script&lang=js"
export * from "./doSeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports